import { useMemo, useRef, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { randomSlogan, sloganParts } from '../lib/slogans';
import { withViewTransition } from '../lib/viewTransition';

/** Landing page: a random slogan above one large search box that opens the Library with the text. */
export function Home() {
  const navigate = useNavigate();
  const slogan = useMemo(() => randomSlogan(), []);
  const [text, setText] = useState('');
  const input = useRef<HTMLInputElement>(null);

  function submit(e: FormEvent) {
    e.preventDefault();
    const q = text.trim();
    // The search box glides into the Library's toolbar (view-transition-name prism-search, 1.2.6).
    withViewTransition(() => navigate(q ? `/library?q=${encodeURIComponent(q)}` : '/library'));
  }

  return (
    <div className="home" data-testid="home">
      <div className="home-inner">
        <h1 className="home-slogan" data-testid="home-slogan">
          {sloganParts(slogan).map((p, i) => (p.hot ? <em key={i}>{p.text}</em> : <span key={i}>{p.text}</span>))}
        </h1>
        <form className="home-search" role="search" onSubmit={submit}>
          <Search size={22} aria-hidden />
          <input
            ref={input}
            className="home-input"
            type="search"
            autoFocus
            autoComplete="off"
            spellCheck={false}
            placeholder="Search titles, keywords, descriptions, filenames…"
            aria-label="Search the library"
            value={text}
            onChange={(e) => setText(e.target.value)}
            data-testid="home-search"
          />
          <button type="submit" className="btn primary home-go" data-testid="home-go">Search</button>
        </form>
        <p className="home-help">Use * as a wildcard, e.g. interv*</p>
      </div>
    </div>
  );
}
